/** @format */

import React, { useContext } from "react";
import { v4 as uuidv4 } from "uuid";
//react-slick
import Slider from "react-slick";

//material ui
import { useMediaQuery, Typography, Button, Box } from "@mui/material";
import { useTheme } from "@mui/styles";

//icons
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

//img
import RightArrow from "../../img/RightArrow.svg";
import LeftArrow from "../../img/LeftArrow.svg";

//json2mq
import json2mq from "json2mq";
import SyllabusCard from "../SyllabusCard/SyllabusCard";
import { useLocation } from "react-router-dom";
import useTranslation from "../../hooks/useTranslation";
import { ColorContext } from "../../pages/Bootcamp";

const useStyles = (theme, isMobile, colorContext) => ({
  container: {
    width: "100%",
    marginTop: "3rem",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
  slider: {
    //margin: "3rem",
    width: "99%",
    height: "fit-content",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  span: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  arrow: {
    color: theme.palette.grey.main,
    fontSize: "2rem",
    fontWeight: "light",
  },
  downloadButton: {
    width: "245px",
    height: "52px",
    borderRadius: "100px",
    textAlign: "center",
    background: `linear-gradient(90deg, ${colorContext.mainColor} 0%, ${colorContext.secondaryColor} 100%)`,
    color: theme.palette.white.main,
    textTransform: "none",
    fontSize: 15.5,
    fontWeight: 550,
  },
  icon: {
    p: "5px",
    height: "20px",
    width: "20px",
    borderRadius: "58px",
    color: colorContext.iconColor,
    bgcolor: theme.palette.white.main,
    ml: "3px",
  },
  typography: {
    descriptionSubtitle: {
      fontSize: isMobile ? 14 : 16,
      textAlign: "center",
      fontWeight: "bold",
      letterSpacing: "2px",
      color: theme.palette.red.main,
      margin: "3rem 0 3rem 0",
    },
    descriptionTitle: {
      fontSize: isMobile ? 32 : 65,
      fontWeight: "lighter",
      textAlign: "center",
      fontFamily: theme.typography.montserrat.regular,
      color: theme.palette.blue.main,
      lineHeight: "43px",
    },
  },
  titleContainer: {
    display: { md: "flex" },
    flexDirection: "column",
    justifyContent: { md: "center" },
    alignItems: { md: "center" },
    gap: "1rem",
    title: {
      color: theme.palette.red.main,
      fontSize: { xs: "14px", md: "16px" },
      letterSpacing: { xs: "1.4px", md: "1.6px" },
      fontFamily: theme.typography.montserrat.semibold,
    },
    line: {
      width: "25px",
      border: `1px solid ${theme.palette.red.main}`,
      marginRight: "8px",
      height: 0,
      backgroundColor: theme.palette.red.main,
    },
  },
});

function Arrow(props) {
  const theme = useTheme();
  const isMobile = useMediaQuery("(max-width:899px)");
  const { mainColor, secondaryColor, iconColor, colorTheme } =
    useContext(ColorContext);
  const classes = useStyles(theme, isMobile, {
    mainColor,
    secondaryColor,
    iconColor,
    colorTheme,
  });
  let className = props.type === "next" ? "nextArrow" : "prevArrow";
  className += " arrow";

  const char =
    props.type === "next" ? (
      <img
        src={RightArrow}
        alt="flecha"
        style={{
          ...classes.arrow,
          height: isMobile ? "1.5rem" : "2.3rem",
          marginRight: ".5rem",
        }}
      />
    ) : (
      <img
        alt="flecha"
        src={LeftArrow}
        style={{
          ...classes.arrow,
          height: isMobile ? "1.5rem" : "2.3rem",
          marginLeft: ".5rem",
        }}
      />
    );

  return (
    <span className={className} onClick={props.onClick} style={classes.span}>
      {char}
    </span>
  );
}

const UnitsCarrousel = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery("(max-width:899px)");
  const { mainColor, secondaryColor, iconColor, colorTheme } =
    useContext(ColorContext);
  const classes = useStyles(theme, isMobile, {
    mainColor,
    secondaryColor,
    iconColor,
    colorTheme,
  });
  
  const xl = useMediaQuery(
    json2mq({
      minWidth: 1641,
    })
  );

  const handleNavigation = (bootcampName) => {
    window
    .open(process.env[`REACT_APP_GOOGLE_DRIVE_BC_${bootcampName.toUpperCase()}`], "_blank")
    .focus();
  };
  
  const sliderSettings = {
    infinite: true,
    slidesToShow: isMobile ? 1 : xl ? 3 : 2,
    adaptiveHeight: true,
  };
  
  const { pathname } = useLocation();
  const bootcampName = pathname.split("/")[2];
  const componentName = "UnitsCarrousel";
  const translation = useTranslation(pathname, componentName);
  const { title, subtitle, button, units } = translation;

  return (
    <Box sx={classes.container}>
      <Box sx={classes.titleContainer}>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {isMobile ? null : <div style={classes.titleContainer.line}></div>}
          <Typography sx={classes.titleContainer.title}>{title}</Typography>
        </div>

        <Typography sx={classes.typography.descriptionTitle}>
          <b>{subtitle}</b>
        </Typography>
      </Box>
      <Slider
        {...sliderSettings}
        adaptiveHeight={false}
        nextArrow={<Arrow type="next" />}
        prevArrow={<Arrow type="prev" />}
        style={classes.slider}
      >
        {units.map((unit) => (
          <SyllabusCard
            key={uuidv4()}
            units={unit.unit}
            stage={unit.stage}
            period={unit.period}
            title={unit.title}
            lessons={unit.lessons}
            color={colorTheme}
          />
        ))}
      </Slider>

      <Button
        sx={classes.downloadButton}
        endIcon={<ArrowForwardIosIcon sx={classes.icon} />}
        variant="contained"
        onClick={() => handleNavigation(bootcampName)}
      >
        {button}
      </Button>
    </Box>
  );
};

export default UnitsCarrousel;
